import { c as _c } from "react/compiler-runtime";
import { DateRangePicker, Tooltip, getDate, getPaymentProcessorTitle } from '@systemeio/ui';
import ContactInfoTooltip from 'modules/contacts/components/contact-info-tooltip';
import ContactPaymentsAmountTooltip from 'modules/contacts/contact-page/components/contact-payments-amount-tooltip';
import ContactPaymentsPaymentTooltip from 'modules/contacts/contact-page/components/contact-paymnet-tooltip';
import { ContactPaymentsStatusEnum } from 'modules/contacts/contact-page/enums/contact-payments-enum';
import { useContactPayments } from 'modules/contacts/contact-page/hooks/use-contact-payments';
import { ContactPageFilterInterface } from 'modules/contacts/contact-page/types/contact-page-filter-interface';
import { ContactPaymentsInterface } from 'modules/contacts/contact-page/types/contact-payments-interface';
import { getContactPaymentUrl } from 'modules/contacts/contact-page/utils/get-contact-payment-url';
import { ContactId, ContactInterface } from 'modules/contacts/types/contact-interface';
import RefundConfirmation from 'modules/payment/transactions/components/refund-confirmation-modal';
import React, { useEffect } from 'react';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { useFilterPagination } from 'shared/route-query/hooks/use-filter-pagination';
import { OrderEnum } from 'shared/types/pagination-interface';
import { dateFormat, dateTimeFormat } from 'shared/utils/date-time-format';
import { getDateRangeSinceDate, getToday } from 'shared/utils/get-dates';
import { OpenInNewIcon, PercentIcon, RefundIcon } from '@systemeio/ui/icons';
interface ContactPaymentsProps {
  contactId: ContactId;
  contact?: ContactInterface;
}
const defaultFilters: ContactPageFilterInterface = {
  date: [null, null]
};
const ContactPayments = t0 => {
  const $ = _c(105);
  const {
    contactId,
    contact
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    intlLocale
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit,
    filter,
    setFilter
  } = useFilterPagination(defaultFilters, true);
  const t1 = filter.date[0] !== null;
  let t2;
  if ($[0] !== contactId || $[1] !== filter || $[2] !== limit || $[3] !== pagination || $[4] !== t1) {
    t2 = {
      contactId,
      limit,
      pagination,
      filter,
      shouldFetch: t1
    };
    $[0] = contactId;
    $[1] = filter;
    $[2] = limit;
    $[3] = pagination;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    contactPayments,
    mutate
  } = useContactPayments(t2);
  let t3;
  if ($[6] !== contact || $[7] !== setFilter || $[8] !== user?.timezone) {
    t3 = () => {
      if (contact) {
        setFilter({
          date: getDateRangeSinceDate(contact.createdAt, user?.timezone)
        });
      }
    };
    $[6] = contact;
    $[7] = setFilter;
    $[8] = user?.timezone;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = user?.timezone;
  let t5;
  if ($[10] !== contact || $[11] !== setFilter || $[12] !== t4) {
    t5 = [contact, setFilter, t4];
    $[10] = contact;
    $[11] = setFilter;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  useEffect(t3, t5);
  let t6;
  if ($[14] !== t || $[15] !== user?.dateFormat || $[16] !== user?.timeFormat || $[17] !== user?.timezone) {
    t6 = {
      key: "paymentProcessorName",
      header: "#",
      widthPercent: 15,
      onRender: payment => <div className="flex gap-1.5"><ContactInfoTooltip fields={payment.customer.fieldValues} referredByEmail={payment.customer.referredBy?.email}><span>{getPaymentProcessorTitle(payment.paymentProcessorName)}</span></ContactInfoTooltip>{payment.status === ContactPaymentsStatusEnum.refunded && payment.refundedAt && <Tooltip mode="hover" label={`${t("global.refunded")} (${dateTimeFormat(payment.refundedAt, {
          timeFormat: user?.timeFormat,
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })})`}><RefundIcon className="fill-orange h-[20px] w-[20px]" /></Tooltip>}</div>
    };
    $[14] = t;
    $[15] = user?.dateFormat;
    $[16] = user?.timeFormat;
    $[17] = user?.timezone;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t) {
    t7 = t("global.date");
    $[19] = t;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== user?.dateFormat || $[22] !== user?.timeFormat || $[23] !== user?.timezone) {
    t8 = payment_0 => <Tooltip wrapperClassName="w-full" mode="hover" label={dateTimeFormat(payment_0.paidAt, {
      timeFormat: user?.timeFormat,
      dateFormat: user?.dateFormat,
      timeZone: user?.timezone
    })}><span className="w-full truncate">{dateFormat(payment_0.paidAt, {
          dateFormat: user?.dateFormat,
          timeZone: user?.timezone
        })}</span></Tooltip>;
    $[21] = user?.dateFormat;
    $[22] = user?.timeFormat;
    $[23] = user?.timezone;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = {
      key: "paidAt",
      header: t7,
      widthPercent: 20,
      onRender: t8
    };
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== t) {
    t10 = t("dashboard.contact_page.total");
    $[28] = t;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10) {
    t11 = {
      key: "payment",
      header: t10,
      widthPercent: 15,
      onRender: _temp
    };
    $[30] = t10;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t) {
    t12 = t("dashboard.contact_page.plan_product");
    $[32] = t;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t12) {
    t13 = {
      key: "payment",
      header: t12,
      onRender: _temp2,
      onRenderSmall: _temp3,
      widthPercent: 30
    };
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t11 || $[37] !== t13 || $[38] !== t6 || $[39] !== t9) {
    t14 = [t6, t9, t11, t13];
    $[36] = t11;
    $[37] = t13;
    $[38] = t6;
    $[39] = t9;
    $[40] = t14;
  } else {
    t14 = $[40];
  }
  const columns = t14;
  let t15;
  if ($[41] !== mutate) {
    t15 = async () => {
      await mutate();
    };
    $[41] = mutate;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  const onUpdate = t15;
  let t16;
  if ($[43] !== contact || $[44] !== t) {
    t16 = contact ? <LinkWithoutPrefetch className="text-text-primary hover:text-brand-primary focus-visible:text-brand-primary group text-[17px] outline-hidden transition-colors duration-200 ease-linear" href={`/payment/transactions?filter=%7B%22email%22%3A%22${contact.email}%22%7D`}><div className="flex items-center gap-1.5">{t("dashboard.contact_page.payments")}<OpenInNewIcon className="fill-text-primary group-hover:fill-brand-primary transition-colors duration-200 ease-linear" /></div></LinkWithoutPrefetch> : <span className="text-[17px]">{t("dashboard.contact_page.payments")}</span>;
    $[43] = contact;
    $[44] = t;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  const t17 = user?.timezone;
  let t18;
  if ($[46] !== t17) {
    t18 = getToday(t17);
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  const t19 = contact?.createdAt;
  const t20 = user?.timezone;
  let t21;
  if ($[48] !== t19 || $[49] !== t20) {
    t21 = getDate(t19, t20);
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== contact?.createdAt || $[52] !== user?.timezone) {
    t22 = () => getDateRangeSinceDate(contact?.createdAt, user?.timezone);
    $[51] = contact?.createdAt;
    $[52] = user?.timezone;
    $[53] = t22;
  } else {
    t22 = $[53];
  }
  let t23;
  if ($[54] !== setFilter || $[55] !== setLimit || $[56] !== setPagination) {
    t23 = date => {
      setPagination({
        startFromId: undefined,
        order: OrderEnum.next
      });
      setLimit(10);
      setFilter({
        date
      });
    };
    $[54] = setFilter;
    $[55] = setLimit;
    $[56] = setPagination;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  const t24 = user?.timezone;
  const t25 = user?.createdAt;
  let t26;
  if ($[58] !== filter.date || $[59] !== intlLocale || $[60] !== t18 || $[61] !== t21 || $[62] !== t22 || $[63] !== t23 || $[64] !== t24 || $[65] !== t25) {
    t26 = <DateRangePicker maxDate={t18} minDate={t21} getDefaultDate={t22} date={filter.date} onChange={t23} timezone={t24} createdAt={t25} intlLocale={intlLocale} />;
    $[58] = filter.date;
    $[59] = intlLocale;
    $[60] = t18;
    $[61] = t21;
    $[62] = t22;
    $[63] = t23;
    $[64] = t24;
    $[65] = t25;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== limit || $[68] !== setLimit) {
    t27 = {
      limit,
      setLimit
    };
    $[67] = limit;
    $[68] = setLimit;
    $[69] = t27;
  } else {
    t27 = $[69];
  }
  let t28;
  if ($[70] !== pagination || $[71] !== setPagination) {
    t28 = {
      pagination,
      setPagination
    };
    $[70] = pagination;
    $[71] = setPagination;
    $[72] = t28;
  } else {
    t28 = $[72];
  }
  let t29;
  if ($[73] !== t) {
    t29 = t("dashboard.contact_page.download_invoice");
    $[73] = t;
    $[74] = t29;
  } else {
    t29 = $[74];
  }
  let t30;
  if ($[75] !== t29) {
    t30 = {
      name: "download-invoice",
      caption: t29,
      setHref: _temp4,
      openInNew: false,
      shouldRender: _temp5
    };
    $[75] = t29;
    $[76] = t30;
  } else {
    t30 = $[76];
  }
  let t31;
  if ($[77] !== t) {
    t31 = t("dashboard.user.affiliate");
    $[77] = t;
    $[78] = t31;
  } else {
    t31 = $[78];
  }
  let t32;
  if ($[79] !== t31) {
    t32 = {
      name: "affiliate",
      caption: t31,
      shouldRender: _temp6,
      setHref: _temp7,
      isNext: true,
      openInNew: false
    };
    $[79] = t31;
    $[80] = t32;
  } else {
    t32 = $[80];
  }
  let t33;
  if ($[81] !== t30 || $[82] !== t32) {
    t33 = [t30, t32];
    $[81] = t30;
    $[82] = t32;
    $[83] = t33;
  } else {
    t33 = $[83];
  }
  let t34;
  if ($[84] !== t) {
    t34 = t("dashboard.contact_page.refund");
    $[84] = t;
    $[85] = t34;
  } else {
    t34 = $[85];
  }
  let t35;
  if ($[86] !== onUpdate) {
    t35 = (opened, onClose, transaction, key) => <RefundConfirmation key={key} opened={opened} onClose={onClose} paymentProcessorName={transaction.paymentProcessorName} transactionId={transaction.id} onUpdate={onUpdate} />;
    $[86] = onUpdate;
    $[87] = t35;
  } else {
    t35 = $[87];
  }
  let t36;
  if ($[88] !== t34 || $[89] !== t35) {
    t36 = [{
      shouldRender: _temp8,
      name: "refund",
      caption: t34,
      onActionRender: t35
    }];
    $[88] = t34;
    $[89] = t35;
    $[90] = t36;
  } else {
    t36 = $[90];
  }
  let t37;
  if ($[91] !== t33 || $[92] !== t36) {
    t37 = {
      openLink: t33,
      custom: t36
    };
    $[91] = t33;
    $[92] = t36;
    $[93] = t37;
  } else {
    t37 = $[93];
  }
  let t38;
  if ($[94] !== columns || $[95] !== contactPayments || $[96] !== t27 || $[97] !== t28 || $[98] !== t37) {
    t38 = <Table limiter={t27} paginator={t28} actions={t37} data={contactPayments} columns={columns} />;
    $[94] = columns;
    $[95] = contactPayments;
    $[96] = t27;
    $[97] = t28;
    $[98] = t37;
    $[99] = t38;
  } else {
    t38 = $[99];
  }
  let t39;
  if ($[100] !== contactPayments || $[101] !== t16 || $[102] !== t26 || $[103] !== t38) {
    t39 = <ListingLayout counter={false} data={contactPayments} type="default" title={t16} customHeaderElement={t26}>{t38}</ListingLayout>;
    $[100] = contactPayments;
    $[101] = t16;
    $[102] = t26;
    $[103] = t38;
    $[104] = t39;
  } else {
    t39 = $[104];
  }
  return t39;
};
export default ContactPayments;
function _temp(payment_1) {
  return <ContactPaymentsAmountTooltip contactPayment={payment_1} />;
}
function _temp2(payment_2) {
  return <div className="flex w-full flex-col">{payment_2.paymentItems.map((el, idx) => <div key={idx} className={`py-3 ${idx !== 0 && "border-text-secondary/30 border-t"} ${idx === 0 && "pt-0"} ${idx + 1 === payment_2.paymentItems.length && "pb-0"}`}><div className="flex items-center gap-1.5"><ContactPaymentsPaymentTooltip orderItem={el.orderItem} />{payment_2.customer.referredBy && <Tooltip label={payment_2.customer.referredBy.email} mode="hover"><PercentIcon className="fill-text-tertiary" /></Tooltip>}</div></div>)}</div>;
}
function _temp3(payment_3) {
  return <div className="flex flex-col truncate">{payment_3.paymentItems.map((el_0, idx_0) => <div key={idx_0} className={` truncate py-3 ${idx_0 !== 0 && "border-text-secondary/30 border-t"} ${idx_0 === 0 && "pt-0"} ${idx_0 + 1 === payment_3.paymentItems.length && "pb-0"}`}><div className="flex items-center gap-1.5 truncate">{el_0.orderItem.offer && el_0.orderItem.offer.removedAt === null && el_0.orderItem.offer.funnelStep ? <LinkWithoutPrefetch rel="noreferrer" className="primary-link w-full truncate" href={getContactPaymentUrl(el_0.orderItem.offer.funnelStep.funnel.id, el_0.orderItem.offer.funnelStep.id)}>{el_0.orderItem.pricePlan ? el_0.orderItem.pricePlan.innerName : el_0.orderItem.productOrderItem && el_0.orderItem.productOrderItem.product.name}</LinkWithoutPrefetch> : el_0.orderItem.pricePlan ? el_0.orderItem.pricePlan.innerName : el_0.orderItem.productOrderItem && el_0.orderItem.productOrderItem.product.name}{payment_3.customer.referredBy && <PercentIcon className="fill-text-tertiary" />}</div></div>)}</div>;
}
function _temp4(payment_4) {
  return `/payment/sales-invoice/${payment_4.salesInvoice?.id}/download`;
}
function _temp5(payment_5) {
  return payment_5.salesInvoice !== null;
}
function _temp6(payment_6) {
  return payment_6.customer.referredBy !== null;
}
function _temp7(payment_7) {
  return `/affiliate-program/${payment_7.customer.referredBy?.id}`;
}
function _temp8(payment_8) {
  return payment_8.canBeRefunded;
}